import styled from 'styled-components';

export const Container = styled.div`
    padding-bottom: 8;
    border-bottom: 1px solid #949494;
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
`;

export const ColorInput = styled.input`
    background-color: transparent;
    border: none;
    width: 27px;
    cursor: pointer;
`;

export const Label = styled.span``;

export const ValueContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    cursor: pointer;
`;

export const ColorValue = styled.span`
    font-size: 16px;
    color: #000;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    margin-left: 4px;

    :focus-visible {
        outline: none;
    }
`;
